import { __assign, __rest } from "tslib";
import React from 'react';
import VeltCommentDialogThreadCardAttachmentsImagePreview from './VeltCommentDialogThreadCardAttachmentsImagePreview/VeltCommentDialogThreadCardAttachmentsImagePreview';
import VeltCommentDialogThreadCardAttachmentsImageDelete from './VeltCommentDialogThreadCardAttachmentsImageDelete/VeltCommentDialogThreadCardAttachmentsImageDelete';
import VeltCommentDialogThreadCardAttachmentsImageDownload from './VeltCommentDialogThreadCardAttachmentsImageDownload/VeltCommentDialogThreadCardAttachmentsImageDownload';
import { transformWireframeProps } from '../../../../../utils/propUtils';
;
var VeltCommentDialogThreadCardAttachmentsImage = function (props) {
    var children = props.children, remainingProps = __rest(props, ["children"]);
    var transformedProps = transformWireframeProps(remainingProps);
    return (React.createElement("velt-comment-dialog-thread-card-attachments-image-wireframe", __assign({}, transformedProps), children));
};
VeltCommentDialogThreadCardAttachmentsImage.Preview = VeltCommentDialogThreadCardAttachmentsImagePreview;
VeltCommentDialogThreadCardAttachmentsImage.Download = VeltCommentDialogThreadCardAttachmentsImageDownload;
VeltCommentDialogThreadCardAttachmentsImage.Delete = VeltCommentDialogThreadCardAttachmentsImageDelete;
export default VeltCommentDialogThreadCardAttachmentsImage;
